import { useEffect, useState } from "react";
import { initializeMsal, msalInstance } from "./msal";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { userDataLoginRequest } from "./authConfig";

const MyMsalProvider = ({ children } ) => {
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const init = async () => {
            await initializeMsal();
            setIsInitialized(true);
        };
        init();
 }, []);

    if (!isInitialized) {
        return <div>Loading...</div>; // or a loading spinner
    }

    return (
        <MsalProvider instance={msalInstance}>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={userDataLoginRequest}
            >
                {children}
            </MsalAuthenticationTemplate>
        </MsalProvider>
    );
};

export default MyMsalProvider;